import { render, staticRenderFns } from "./editChapter.vue?vue&type=template&id=2096d7b8"
import script from "./editChapter.vue?vue&type=script&lang=js"
export * from "./editChapter.vue?vue&type=script&lang=js"
import style0 from "./editChapter.vue?vue&type=style&index=0&id=2096d7b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports